import React, { useState } from 'react';
import ScrollablePickList from './ScrollablePickList';
import Flex from '../containers/Flex';
import Tickbox from '../Tickbox';
import AsLabel from '../AsLabel';
import Spacer from '../Spacer';
import AsButton from '../AsButton';
import { normaliseData } from './pickListCommon';
import PropTypes from 'prop-types';

const sortData = (a, b) => {
    if (typeof a.values[0] === 'number' && typeof b.values[0] === 'number') {
        return a.values[0] - b.values[0];
    }

    if (typeof a.values[0] === 'string' && typeof b.values[0] === 'string') {
        const ua = a.values[0].toUpperCase();
        const ub = b.values[0].toUpperCase();
        // Put empty rows at the end
        if (ub === '' || ua < ub) {
            return -1;
        }
        if (ua > ub) {
            return 1;
        }
    }
    return 0;
};

const hasChanged = (dataA, dataB) => {
    for (let i = 0; i < dataA.length; i++) {
        for (let j = 0; j < dataA[i].values.length; j++) {
            if (dataA[i].values[j] !== dataB[i].values[j]) {
                return true;
            }
        }
    }
    return false;
};

const SortablePickList = ({
    data,
    setData,
    height,
    maxItems,
    types,
    keyToDisplay,
    ...props
}) => {
    const [sortedData, setSortedData] = useState(
        normaliseData(types, data, maxItems).sort(sortData)
    );
    const [unsortedData, setUnsortedData] = useState(
        normaliseData(types, data, maxItems)
    );
    const [sortTicked, setSortTicked] = useState(false);

    return (
        <Flex id='pick-list-sortable-container' style={{ width: '100%' }}>
            <ScrollablePickList
                {...props}
                data={sortTicked ? sortedData : unsortedData}
                setData={sortTicked ? setSortedData : setUnsortedData}
                height={height}
                maxItems={maxItems}
                types={types}
                keyToDisplay={keyToDisplay}
            />

            <Flex
                id='pick-list-action-panel'
                style={{
                    flexDirection: 'column',
                    width: 300,
                    justifyContent: 'flex-end'
                }}
            >
                <Flex
                    id='tickbox-sort-container'
                    style={{ justifyContent: 'right' }}
                >
                    <Tickbox
                        name='tickbox-sort'
                        value={sortTicked}
                        onClick={() => {
                            setSortTicked(!sortTicked);
                            const data = sortedData.sort(sortData);
                            setSortedData(data);
                        }}
                    />

                    <Spacer width={18} />

                    <AsLabel id='tickbox-sort-label'>
                        Display values alphabetically
                    </AsLabel>
                </Flex>

                <Flex style={{ justifyContent: 'right' }}>
                    <AsButton
                        disabled={
                            !hasChanged(
                                data,
                                sortTicked ? sortedData : unsortedData
                            )
                        }
                        onClick={() => {
                            setData(sortTicked ? sortedData : unsortedData);
                        }}
                    >
                        Save
                    </AsButton>
                </Flex>
            </Flex>
        </Flex>
    );
};

SortablePickList.defaultProps = {
    minItems: 1
};

SortablePickList.propTypes = {
    types: PropTypes.arrayOf(PropTypes.oneOf(['text', 'number', 'currency']))
        .isRequired,
    maxItems: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    setData: PropTypes.func
};

export default SortablePickList;
